/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * OpenAPI
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { customInstance } from "../lib/api-client";
export type GetUserMe200 = {
  user: unknown;
};

export type GetUserMe401 = {
  error: string;
};

export type PutUpdateKaiapayIdBody = {
  /**
   * @minLength 4
   * @maxLength 16
   * @pattern ^[a-zA-Z0-9가-힣]+$
   */
  kaiapayId: string;
};

export type PutUpdateKaiapayId200 = {
  kaiapayId: string;
};

export type PutUpdateKaiapayId400 = {
  code: string;
  message: string;
};

export type PutUpdateKaiapayId401 = {
  error: string;
};

export type PutUpdateKaiapayId409 = {
  code: string;
  message: string;
};

export type PutUpdateKaiapayId500 = {
  code: string;
  message: string;
};

export type PostDepositBody = {
  txHash: string;
};

export type PostDeposit200 = {
  message: string;
};

export type PostDeposit400 = {
  code: string;
  message: string;
};

export type PostDeposit401 = {
  error: string;
};

export type PostDeposit500 = {
  code: string;
  message: string;
};

export type PostTransferWithLinkBodyMethod =
  (typeof PostTransferWithLinkBodyMethod)[keyof typeof PostTransferWithLinkBodyMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostTransferWithLinkBodyMethod = {
  link: "link",
  phone: "phone",
} as const;

export type PostTransferWithLinkBody = {
  amount: string;
  token: string;
  method: PostTransferWithLinkBodyMethod;
  phone?: string;
};

export type PostTransferWithLink200 = {
  transactionId: string;
  link: string;
  publicAddress: string;
};

export type PostTransferWithLink400 = {
  code: string;
  message: string;
};

export type PostTransferWithLink401 = {
  error: string;
};

export type PostTransferWithLink500 = {
  code: string;
  message: string;
};

export type PostTransferWithKaiapayIdBody = {
  amount: string;
  token: string;
  kaiapayId: string;
};

export type PostTransferWithKaiapayId200 = {
  transactionId: string;
  publicAddress: string;
};

export type PostTransferWithKaiapayId400 = {
  code: string;
  message: string;
};

export type PostTransferWithKaiapayId401 = {
  error: string;
};

export type PostTransferWithKaiapayId404 = {
  code: string;
  message: string;
};

export type PostTransferWithKaiapayId500 = {
  code: string;
  message: string;
};

export type PostConfirmTransferBody = {
  transactionId: string;
  txHash: string;
};

export type PostConfirmTransfer200 = {
  message: string;
};

export type PostConfirmTransfer400 = {
  code: string;
  message: string;
};

export type PostConfirmTransfer401 = {
  error: string;
};

export type PostConfirmTransfer404 = {
  code: string;
  message: string;
};

export type PostConfirmTransfer500 = {
  code: string;
  message: string;
};

export type PostConfirmWithdrawBody = {
  transactionId: string;
  txHash: string;
};

export type PostConfirmWithdraw200 = {
  message: string;
};

export type PostConfirmWithdraw400 = {
  code: string;
  message: string;
};

export type PostConfirmWithdraw401 = {
  error: string;
};

export type PostConfirmWithdraw404 = {
  code: string;
  message: string;
};

export type PostConfirmWithdraw500 = {
  code: string;
  message: string;
};

export type PostTransferWithExternalAddressBody = {
  amount: string;
  token: string;
  address: string;
};

export type PostTransferWithExternalAddress200 = {
  transactionId: string;
};

export type PostTransferWithExternalAddress400 = {
  code: string;
  message: string;
};

export type PostTransferWithExternalAddress401 = {
  error: string;
};

export type PostTransferWithExternalAddress500 = {
  code: string;
  message: string;
};

export type GetTransactionGetById200TransactionStatus =
  (typeof GetTransactionGetById200TransactionStatus)[keyof typeof GetTransactionGetById200TransactionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionGetById200TransactionStatus = {
  pending: "pending",
  processing: "processing",
  success: "success",
  canceled: "canceled",
  failed: "failed",
  expired: "expired",
} as const;

export type GetTransactionGetById200TransactionMethod =
  (typeof GetTransactionGetById200TransactionMethod)[keyof typeof GetTransactionGetById200TransactionMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionGetById200TransactionMethod = {
  link: "link",
  kaiapayId: "kaiapayId",
  phone: "phone",
  wallet: "wallet",
  luckybox: "luckybox",
  interest: "interest",
  payment: "payment",
} as const;

export type GetTransactionGetById200TransactionKind =
  (typeof GetTransactionGetById200TransactionKind)[keyof typeof GetTransactionGetById200TransactionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionGetById200TransactionKind = {
  send_to_user: "send_to_user",
  send_to_temporal: "send_to_temporal",
  receive: "receive",
  interest: "interest",
  payment: "payment",
  withdraw: "withdraw",
  deposit: "deposit",
} as const;

export type GetTransactionGetById200Transaction = {
  id: string;
  amount: string;
  token: string;
  fromAddress: string;
  toAddress: string;
  senderAlias: string;
  recipientAlias: string;
  status: GetTransactionGetById200TransactionStatus;
  method: GetTransactionGetById200TransactionMethod;
  kind: GetTransactionGetById200TransactionKind;
  updatedAt: string;
};

export type GetTransactionGetById200 = {
  transaction: GetTransactionGetById200Transaction;
};

export type GetTransactionGetById401 = {
  error: string;
};

export type GetTransactionListParams = {
  limit?: number;
};

export type GetTransactionList200TransactionsItemStatus =
  (typeof GetTransactionList200TransactionsItemStatus)[keyof typeof GetTransactionList200TransactionsItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionList200TransactionsItemStatus = {
  pending: "pending",
  processing: "processing",
  success: "success",
  canceled: "canceled",
  failed: "failed",
  expired: "expired",
} as const;

export type GetTransactionList200TransactionsItemMethod =
  (typeof GetTransactionList200TransactionsItemMethod)[keyof typeof GetTransactionList200TransactionsItemMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionList200TransactionsItemMethod = {
  link: "link",
  kaiapayId: "kaiapayId",
  phone: "phone",
  wallet: "wallet",
  luckybox: "luckybox",
  interest: "interest",
  payment: "payment",
} as const;

export type GetTransactionList200TransactionsItemKind =
  (typeof GetTransactionList200TransactionsItemKind)[keyof typeof GetTransactionList200TransactionsItemKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionList200TransactionsItemKind = {
  send_to_user: "send_to_user",
  send_to_temporal: "send_to_temporal",
  receive: "receive",
  interest: "interest",
  payment: "payment",
  withdraw: "withdraw",
  deposit: "deposit",
} as const;

export type GetTransactionList200TransactionsItem = {
  id: string;
  amount: string;
  token: string;
  fromAddress: string;
  toAddress: string;
  senderAlias: string;
  recipientAlias: string;
  status: GetTransactionList200TransactionsItemStatus;
  method: GetTransactionList200TransactionsItemMethod;
  kind: GetTransactionList200TransactionsItemKind;
  canCancel: boolean;
  updatedAt: string;
  canceledAt?: string;
  txHash?: string;
  deadline: string;
};

export type GetTransactionList200 = {
  todayCount: number;
  transactions: GetTransactionList200TransactionsItem[];
};

export type GetTransactionList401 = {
  error: string;
};

export type PostTransferFromLinkBody = {
  prevTransactionId: string;
  txHash: string;
};

export type PostTransferFromLink200 = {
  transactionId: string;
};

export type PostTransferFromLink400 = {
  code: string;
  message: string;
};

export type PostTransferFromLink401 = {
  error: string;
};

export type PostTransferFromLink500 = {
  code: string;
  message: string;
};

export type PostCreatePaymentBodyAmount = string | null;

export type PostCreatePaymentBodyCurrency = "USDT" | "KAIA" | null;

export type PostCreatePaymentBody = {
  title: string;
  amount: PostCreatePaymentBodyAmount;
  currency: PostCreatePaymentBodyCurrency;
};

export type PostCreatePayment200 = {
  url: string;
};

export type PostCreatePayment401 = {
  error: string;
};

export type PostCreatePayment500 = {
  code: string;
  message: string;
};

export type GetGetPaymentByCode200Payment = {
  code: string;
  title: string;
  amount?: string;
  currency?: string;
  receiverAddress: string;
};

export type GetGetPaymentByCode200 = {
  payment: GetGetPaymentByCode200Payment;
};

export type GetGetPaymentByCode401 = {
  error: string;
};

export type PostRelayFeePayBody = {
  userSignedTx: string;
};

export type PostRelayFeePay200 = {
  hash: string;
};

export type PostRelayFeePay401 = {
  error: string;
};

export type PostRelayFeePay500OneOfCode =
  (typeof PostRelayFeePay500OneOfCode)[keyof typeof PostRelayFeePay500OneOfCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostRelayFeePay500OneOfCode = {
  SIGN_ERROR: "SIGN_ERROR",
} as const;

export type PostRelayFeePay500OneOf = {
  code: PostRelayFeePay500OneOfCode;
  message: string;
};

export type GetFeePayerBalance200Item = {
  publicAddress: string;
  balance: string;
};

export type GetPublicTransactionGetByToAddressParams = {
  address: string;
};

export type GetPublicTransactionGetByToAddress200TransactionStatus =
  (typeof GetPublicTransactionGetByToAddress200TransactionStatus)[keyof typeof GetPublicTransactionGetByToAddress200TransactionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPublicTransactionGetByToAddress200TransactionStatus = {
  pending: "pending",
  processing: "processing",
  success: "success",
  canceled: "canceled",
  failed: "failed",
  expired: "expired",
} as const;

export type GetPublicTransactionGetByToAddress200TransactionMethod =
  (typeof GetPublicTransactionGetByToAddress200TransactionMethod)[keyof typeof GetPublicTransactionGetByToAddress200TransactionMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPublicTransactionGetByToAddress200TransactionMethod = {
  link: "link",
  kaiapayId: "kaiapayId",
  phone: "phone",
  wallet: "wallet",
  luckybox: "luckybox",
  interest: "interest",
  payment: "payment",
} as const;

export type GetPublicTransactionGetByToAddress200TransactionKind =
  (typeof GetPublicTransactionGetByToAddress200TransactionKind)[keyof typeof GetPublicTransactionGetByToAddress200TransactionKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPublicTransactionGetByToAddress200TransactionKind = {
  send_to_user: "send_to_user",
  send_to_temporal: "send_to_temporal",
  receive: "receive",
  interest: "interest",
  payment: "payment",
  withdraw: "withdraw",
  deposit: "deposit",
} as const;

export type GetPublicTransactionGetByToAddress200Transaction = {
  id: string;
  amount: string;
  token: string;
  fromAddress: string;
  toAddress: string;
  senderAlias: string;
  recipientAlias: string;
  status: GetPublicTransactionGetByToAddress200TransactionStatus;
  method: GetPublicTransactionGetByToAddress200TransactionMethod;
  kind: GetPublicTransactionGetByToAddress200TransactionKind;
  deadline: string;
  canCancel: boolean;
  updatedAt: string;
};

export type GetPublicTransactionGetByToAddress200 = {
  transaction: GetPublicTransactionGetByToAddress200Transaction;
};

export type GetPotInfoParams = {
  address: string;
};

export type GetPotInfo200Item = {
  balance: string;
  deadline: string;
  owner: string;
};

/**
 * @summary Get current user
 */
export const getUserMe = (signal?: AbortSignal) => {
  return customInstance<GetUserMe200>({
    url: `/api/user/me`,
    method: "GET",
    signal,
  });
};

export const getGetUserMeQueryKey = () => {
  return [`/api/user/me`] as const;
};

export const getGetUserMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserMe>>,
  TError = GetUserMe401,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserMe>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserMe>>> = ({
    signal,
  }) => getUserMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserMe>>
>;
export type GetUserMeQueryError = GetUserMe401;

export function useGetUserMe<
  TData = Awaited<ReturnType<typeof getUserMe>>,
  TError = GetUserMe401,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMe>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMe>>,
          TError,
          Awaited<ReturnType<typeof getUserMe>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserMe<
  TData = Awaited<ReturnType<typeof getUserMe>>,
  TError = GetUserMe401,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMe>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMe>>,
          TError,
          Awaited<ReturnType<typeof getUserMe>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserMe<
  TData = Awaited<ReturnType<typeof getUserMe>>,
  TError = GetUserMe401,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMe>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get current user
 */

export function useGetUserMe<
  TData = Awaited<ReturnType<typeof getUserMe>>,
  TError = GetUserMe401,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMe>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Kaiapay ID
 */
export const putUpdateKaiapayId = (
  putUpdateKaiapayIdBody: PutUpdateKaiapayIdBody,
) => {
  return customInstance<PutUpdateKaiapayId200>({
    url: `/api/user/update-kaiapay-id`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: putUpdateKaiapayIdBody,
  });
};

export const getPutUpdateKaiapayIdMutationOptions = <
  TError =
    | PutUpdateKaiapayId400
    | PutUpdateKaiapayId401
    | PutUpdateKaiapayId409
    | PutUpdateKaiapayId500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putUpdateKaiapayId>>,
    TError,
    { data: PutUpdateKaiapayIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putUpdateKaiapayId>>,
  TError,
  { data: PutUpdateKaiapayIdBody },
  TContext
> => {
  const mutationKey = ["putUpdateKaiapayId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putUpdateKaiapayId>>,
    { data: PutUpdateKaiapayIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return putUpdateKaiapayId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutUpdateKaiapayIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putUpdateKaiapayId>>
>;
export type PutUpdateKaiapayIdMutationBody = PutUpdateKaiapayIdBody;
export type PutUpdateKaiapayIdMutationError =
  | PutUpdateKaiapayId400
  | PutUpdateKaiapayId401
  | PutUpdateKaiapayId409
  | PutUpdateKaiapayId500;

/**
 * @summary Update Kaiapay ID
 */
export const usePutUpdateKaiapayId = <
  TError =
    | PutUpdateKaiapayId400
    | PutUpdateKaiapayId401
    | PutUpdateKaiapayId409
    | PutUpdateKaiapayId500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putUpdateKaiapayId>>,
      TError,
      { data: PutUpdateKaiapayIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putUpdateKaiapayId>>,
  TError,
  { data: PutUpdateKaiapayIdBody },
  TContext
> => {
  const mutationOptions = getPutUpdateKaiapayIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deposit
 */
export const postDeposit = (
  postDepositBody: PostDepositBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostDeposit200>({
    url: `/api/transaction/deposit`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postDepositBody,
    signal,
  });
};

export const getPostDepositMutationOptions = <
  TError = PostDeposit400 | PostDeposit401 | PostDeposit500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDeposit>>,
    TError,
    { data: PostDepositBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDeposit>>,
  TError,
  { data: PostDepositBody },
  TContext
> => {
  const mutationKey = ["postDeposit"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDeposit>>,
    { data: PostDepositBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDeposit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDepositMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDeposit>>
>;
export type PostDepositMutationBody = PostDepositBody;
export type PostDepositMutationError =
  | PostDeposit400
  | PostDeposit401
  | PostDeposit500;

/**
 * @summary Deposit
 */
export const usePostDeposit = <
  TError = PostDeposit400 | PostDeposit401 | PostDeposit500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDeposit>>,
      TError,
      { data: PostDepositBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDeposit>>,
  TError,
  { data: PostDepositBody },
  TContext
> => {
  const mutationOptions = getPostDepositMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Transfer with Link
 */
export const postTransferWithLink = (
  postTransferWithLinkBody: PostTransferWithLinkBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostTransferWithLink200>({
    url: `/api/transaction/transfer-with-link`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postTransferWithLinkBody,
    signal,
  });
};

export const getPostTransferWithLinkMutationOptions = <
  TError =
    | PostTransferWithLink400
    | PostTransferWithLink401
    | PostTransferWithLink500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTransferWithLink>>,
    TError,
    { data: PostTransferWithLinkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTransferWithLink>>,
  TError,
  { data: PostTransferWithLinkBody },
  TContext
> => {
  const mutationKey = ["postTransferWithLink"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTransferWithLink>>,
    { data: PostTransferWithLinkBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTransferWithLink(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTransferWithLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTransferWithLink>>
>;
export type PostTransferWithLinkMutationBody = PostTransferWithLinkBody;
export type PostTransferWithLinkMutationError =
  | PostTransferWithLink400
  | PostTransferWithLink401
  | PostTransferWithLink500;

/**
 * @summary Transfer with Link
 */
export const usePostTransferWithLink = <
  TError =
    | PostTransferWithLink400
    | PostTransferWithLink401
    | PostTransferWithLink500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTransferWithLink>>,
      TError,
      { data: PostTransferWithLinkBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTransferWithLink>>,
  TError,
  { data: PostTransferWithLinkBody },
  TContext
> => {
  const mutationOptions = getPostTransferWithLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Transfer with Kaia ID
 */
export const postTransferWithKaiapayId = (
  postTransferWithKaiapayIdBody: PostTransferWithKaiapayIdBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostTransferWithKaiapayId200>({
    url: `/api/transaction/transfer-with-kaiapay-id`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postTransferWithKaiapayIdBody,
    signal,
  });
};

export const getPostTransferWithKaiapayIdMutationOptions = <
  TError =
    | PostTransferWithKaiapayId400
    | PostTransferWithKaiapayId401
    | PostTransferWithKaiapayId404
    | PostTransferWithKaiapayId500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTransferWithKaiapayId>>,
    TError,
    { data: PostTransferWithKaiapayIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTransferWithKaiapayId>>,
  TError,
  { data: PostTransferWithKaiapayIdBody },
  TContext
> => {
  const mutationKey = ["postTransferWithKaiapayId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTransferWithKaiapayId>>,
    { data: PostTransferWithKaiapayIdBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTransferWithKaiapayId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTransferWithKaiapayIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTransferWithKaiapayId>>
>;
export type PostTransferWithKaiapayIdMutationBody =
  PostTransferWithKaiapayIdBody;
export type PostTransferWithKaiapayIdMutationError =
  | PostTransferWithKaiapayId400
  | PostTransferWithKaiapayId401
  | PostTransferWithKaiapayId404
  | PostTransferWithKaiapayId500;

/**
 * @summary Transfer with Kaia ID
 */
export const usePostTransferWithKaiapayId = <
  TError =
    | PostTransferWithKaiapayId400
    | PostTransferWithKaiapayId401
    | PostTransferWithKaiapayId404
    | PostTransferWithKaiapayId500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTransferWithKaiapayId>>,
      TError,
      { data: PostTransferWithKaiapayIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTransferWithKaiapayId>>,
  TError,
  { data: PostTransferWithKaiapayIdBody },
  TContext
> => {
  const mutationOptions = getPostTransferWithKaiapayIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Confirm Transfer
 */
export const postConfirmTransfer = (
  postConfirmTransferBody: PostConfirmTransferBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostConfirmTransfer200>({
    url: `/api/transaction/confirm-transfer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postConfirmTransferBody,
    signal,
  });
};

export const getPostConfirmTransferMutationOptions = <
  TError =
    | PostConfirmTransfer400
    | PostConfirmTransfer401
    | PostConfirmTransfer404
    | PostConfirmTransfer500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postConfirmTransfer>>,
    TError,
    { data: PostConfirmTransferBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postConfirmTransfer>>,
  TError,
  { data: PostConfirmTransferBody },
  TContext
> => {
  const mutationKey = ["postConfirmTransfer"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postConfirmTransfer>>,
    { data: PostConfirmTransferBody }
  > = (props) => {
    const { data } = props ?? {};

    return postConfirmTransfer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostConfirmTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postConfirmTransfer>>
>;
export type PostConfirmTransferMutationBody = PostConfirmTransferBody;
export type PostConfirmTransferMutationError =
  | PostConfirmTransfer400
  | PostConfirmTransfer401
  | PostConfirmTransfer404
  | PostConfirmTransfer500;

/**
 * @summary Confirm Transfer
 */
export const usePostConfirmTransfer = <
  TError =
    | PostConfirmTransfer400
    | PostConfirmTransfer401
    | PostConfirmTransfer404
    | PostConfirmTransfer500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postConfirmTransfer>>,
      TError,
      { data: PostConfirmTransferBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postConfirmTransfer>>,
  TError,
  { data: PostConfirmTransferBody },
  TContext
> => {
  const mutationOptions = getPostConfirmTransferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Confirm Withdraw
 */
export const postConfirmWithdraw = (
  postConfirmWithdrawBody: PostConfirmWithdrawBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostConfirmWithdraw200>({
    url: `/api/transaction/confirm-withdraw`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postConfirmWithdrawBody,
    signal,
  });
};

export const getPostConfirmWithdrawMutationOptions = <
  TError =
    | PostConfirmWithdraw400
    | PostConfirmWithdraw401
    | PostConfirmWithdraw404
    | PostConfirmWithdraw500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postConfirmWithdraw>>,
    TError,
    { data: PostConfirmWithdrawBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postConfirmWithdraw>>,
  TError,
  { data: PostConfirmWithdrawBody },
  TContext
> => {
  const mutationKey = ["postConfirmWithdraw"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postConfirmWithdraw>>,
    { data: PostConfirmWithdrawBody }
  > = (props) => {
    const { data } = props ?? {};

    return postConfirmWithdraw(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostConfirmWithdrawMutationResult = NonNullable<
  Awaited<ReturnType<typeof postConfirmWithdraw>>
>;
export type PostConfirmWithdrawMutationBody = PostConfirmWithdrawBody;
export type PostConfirmWithdrawMutationError =
  | PostConfirmWithdraw400
  | PostConfirmWithdraw401
  | PostConfirmWithdraw404
  | PostConfirmWithdraw500;

/**
 * @summary Confirm Withdraw
 */
export const usePostConfirmWithdraw = <
  TError =
    | PostConfirmWithdraw400
    | PostConfirmWithdraw401
    | PostConfirmWithdraw404
    | PostConfirmWithdraw500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postConfirmWithdraw>>,
      TError,
      { data: PostConfirmWithdrawBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postConfirmWithdraw>>,
  TError,
  { data: PostConfirmWithdrawBody },
  TContext
> => {
  const mutationOptions = getPostConfirmWithdrawMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Transfer with External Address
 */
export const postTransferWithExternalAddress = (
  postTransferWithExternalAddressBody: PostTransferWithExternalAddressBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostTransferWithExternalAddress200>({
    url: `/api/transaction/transfer-with-external-address`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postTransferWithExternalAddressBody,
    signal,
  });
};

export const getPostTransferWithExternalAddressMutationOptions = <
  TError =
    | PostTransferWithExternalAddress400
    | PostTransferWithExternalAddress401
    | PostTransferWithExternalAddress500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTransferWithExternalAddress>>,
    TError,
    { data: PostTransferWithExternalAddressBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTransferWithExternalAddress>>,
  TError,
  { data: PostTransferWithExternalAddressBody },
  TContext
> => {
  const mutationKey = ["postTransferWithExternalAddress"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTransferWithExternalAddress>>,
    { data: PostTransferWithExternalAddressBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTransferWithExternalAddress(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTransferWithExternalAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTransferWithExternalAddress>>
>;
export type PostTransferWithExternalAddressMutationBody =
  PostTransferWithExternalAddressBody;
export type PostTransferWithExternalAddressMutationError =
  | PostTransferWithExternalAddress400
  | PostTransferWithExternalAddress401
  | PostTransferWithExternalAddress500;

/**
 * @summary Transfer with External Address
 */
export const usePostTransferWithExternalAddress = <
  TError =
    | PostTransferWithExternalAddress400
    | PostTransferWithExternalAddress401
    | PostTransferWithExternalAddress500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTransferWithExternalAddress>>,
      TError,
      { data: PostTransferWithExternalAddressBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTransferWithExternalAddress>>,
  TError,
  { data: PostTransferWithExternalAddressBody },
  TContext
> => {
  const mutationOptions =
    getPostTransferWithExternalAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get transaction by id
 */
export const getTransactionGetById = (id: string, signal?: AbortSignal) => {
  return customInstance<GetTransactionGetById200>({
    url: `/api/transaction/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetTransactionGetByIdQueryKey = (id?: string) => {
  return [`/api/transaction/${id}`] as const;
};

export const getGetTransactionGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionGetById>>,
  TError = GetTransactionGetById401,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionGetById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTransactionGetByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransactionGetById>>
  > = ({ signal }) => getTransactionGetById(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransactionGetById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTransactionGetByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionGetById>>
>;
export type GetTransactionGetByIdQueryError = GetTransactionGetById401;

export function useGetTransactionGetById<
  TData = Awaited<ReturnType<typeof getTransactionGetById>>,
  TError = GetTransactionGetById401,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionGetById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionGetById>>,
          TError,
          Awaited<ReturnType<typeof getTransactionGetById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransactionGetById<
  TData = Awaited<ReturnType<typeof getTransactionGetById>>,
  TError = GetTransactionGetById401,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionGetById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionGetById>>,
          TError,
          Awaited<ReturnType<typeof getTransactionGetById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransactionGetById<
  TData = Awaited<ReturnType<typeof getTransactionGetById>>,
  TError = GetTransactionGetById401,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionGetById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get transaction by id
 */

export function useGetTransactionGetById<
  TData = Awaited<ReturnType<typeof getTransactionGetById>>,
  TError = GetTransactionGetById401,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionGetById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTransactionGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get transaction list
 */
export const getTransactionList = (
  params?: GetTransactionListParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetTransactionList200>({
    url: `/api/transaction`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTransactionListQueryKey = (
  params?: GetTransactionListParams,
) => {
  return [`/api/transaction`, ...(params ? [params] : [])] as const;
};

export const getGetTransactionListQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransactionList>>,
  TError = GetTransactionList401,
>(
  params?: GetTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTransactionListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransactionList>>
  > = ({ signal }) => getTransactionList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransactionList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTransactionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransactionList>>
>;
export type GetTransactionListQueryError = GetTransactionList401;

export function useGetTransactionList<
  TData = Awaited<ReturnType<typeof getTransactionList>>,
  TError = GetTransactionList401,
>(
  params: undefined | GetTransactionListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionList>>,
          TError,
          Awaited<ReturnType<typeof getTransactionList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransactionList<
  TData = Awaited<ReturnType<typeof getTransactionList>>,
  TError = GetTransactionList401,
>(
  params?: GetTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionList>>,
          TError,
          Awaited<ReturnType<typeof getTransactionList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransactionList<
  TData = Awaited<ReturnType<typeof getTransactionList>>,
  TError = GetTransactionList401,
>(
  params?: GetTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get transaction list
 */

export function useGetTransactionList<
  TData = Awaited<ReturnType<typeof getTransactionList>>,
  TError = GetTransactionList401,
>(
  params?: GetTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransactionList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTransactionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Transfer from Link
 */
export const postTransferFromLink = (
  postTransferFromLinkBody: PostTransferFromLinkBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostTransferFromLink200>({
    url: `/api/transaction/transfer-from-link`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postTransferFromLinkBody,
    signal,
  });
};

export const getPostTransferFromLinkMutationOptions = <
  TError =
    | PostTransferFromLink400
    | PostTransferFromLink401
    | PostTransferFromLink500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTransferFromLink>>,
    TError,
    { data: PostTransferFromLinkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTransferFromLink>>,
  TError,
  { data: PostTransferFromLinkBody },
  TContext
> => {
  const mutationKey = ["postTransferFromLink"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTransferFromLink>>,
    { data: PostTransferFromLinkBody }
  > = (props) => {
    const { data } = props ?? {};

    return postTransferFromLink(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTransferFromLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTransferFromLink>>
>;
export type PostTransferFromLinkMutationBody = PostTransferFromLinkBody;
export type PostTransferFromLinkMutationError =
  | PostTransferFromLink400
  | PostTransferFromLink401
  | PostTransferFromLink500;

/**
 * @summary Transfer from Link
 */
export const usePostTransferFromLink = <
  TError =
    | PostTransferFromLink400
    | PostTransferFromLink401
    | PostTransferFromLink500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTransferFromLink>>,
      TError,
      { data: PostTransferFromLinkBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTransferFromLink>>,
  TError,
  { data: PostTransferFromLinkBody },
  TContext
> => {
  const mutationOptions = getPostTransferFromLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create Payment
 */
export const postCreatePayment = (
  postCreatePaymentBody: PostCreatePaymentBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostCreatePayment200>({
    url: `/api/payment/create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postCreatePaymentBody,
    signal,
  });
};

export const getPostCreatePaymentMutationOptions = <
  TError = PostCreatePayment401 | PostCreatePayment500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCreatePayment>>,
    TError,
    { data: PostCreatePaymentBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCreatePayment>>,
  TError,
  { data: PostCreatePaymentBody },
  TContext
> => {
  const mutationKey = ["postCreatePayment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCreatePayment>>,
    { data: PostCreatePaymentBody }
  > = (props) => {
    const { data } = props ?? {};

    return postCreatePayment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCreatePaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCreatePayment>>
>;
export type PostCreatePaymentMutationBody = PostCreatePaymentBody;
export type PostCreatePaymentMutationError =
  | PostCreatePayment401
  | PostCreatePayment500;

/**
 * @summary Create Payment
 */
export const usePostCreatePayment = <
  TError = PostCreatePayment401 | PostCreatePayment500,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCreatePayment>>,
      TError,
      { data: PostCreatePaymentBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCreatePayment>>,
  TError,
  { data: PostCreatePaymentBody },
  TContext
> => {
  const mutationOptions = getPostCreatePaymentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get payment by code
 */
export const getGetPaymentByCode = (code: string, signal?: AbortSignal) => {
  return customInstance<GetGetPaymentByCode200>({
    url: `/api/payment/${code}`,
    method: "GET",
    signal,
  });
};

export const getGetGetPaymentByCodeQueryKey = (code?: string) => {
  return [`/api/payment/${code}`] as const;
};

export const getGetGetPaymentByCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getGetPaymentByCode>>,
  TError = GetGetPaymentByCode401,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetPaymentByCode>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGetPaymentByCodeQueryKey(code);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGetPaymentByCode>>
  > = ({ signal }) => getGetPaymentByCode(code, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGetPaymentByCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGetPaymentByCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGetPaymentByCode>>
>;
export type GetGetPaymentByCodeQueryError = GetGetPaymentByCode401;

export function useGetGetPaymentByCode<
  TData = Awaited<ReturnType<typeof getGetPaymentByCode>>,
  TError = GetGetPaymentByCode401,
>(
  code: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetPaymentByCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGetPaymentByCode>>,
          TError,
          Awaited<ReturnType<typeof getGetPaymentByCode>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGetPaymentByCode<
  TData = Awaited<ReturnType<typeof getGetPaymentByCode>>,
  TError = GetGetPaymentByCode401,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetPaymentByCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGetPaymentByCode>>,
          TError,
          Awaited<ReturnType<typeof getGetPaymentByCode>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGetPaymentByCode<
  TData = Awaited<ReturnType<typeof getGetPaymentByCode>>,
  TError = GetGetPaymentByCode401,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetPaymentByCode>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get payment by code
 */

export function useGetGetPaymentByCode<
  TData = Awaited<ReturnType<typeof getGetPaymentByCode>>,
  TError = GetGetPaymentByCode401,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGetPaymentByCode>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGetPaymentByCodeQueryOptions(code, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Relay fee pay
 */
export const postRelayFeePay = (
  postRelayFeePayBody: PostRelayFeePayBody,
  signal?: AbortSignal,
) => {
  return customInstance<PostRelayFeePay200>({
    url: `/api/fee-delegation/relay`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postRelayFeePayBody,
    signal,
  });
};

export const getPostRelayFeePayMutationOptions = <
  TError = PostRelayFeePay401 | PostRelayFeePay500OneOf,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRelayFeePay>>,
    TError,
    { data: PostRelayFeePayBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRelayFeePay>>,
  TError,
  { data: PostRelayFeePayBody },
  TContext
> => {
  const mutationKey = ["postRelayFeePay"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRelayFeePay>>,
    { data: PostRelayFeePayBody }
  > = (props) => {
    const { data } = props ?? {};

    return postRelayFeePay(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRelayFeePayMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRelayFeePay>>
>;
export type PostRelayFeePayMutationBody = PostRelayFeePayBody;
export type PostRelayFeePayMutationError =
  | PostRelayFeePay401
  | PostRelayFeePay500OneOf;

/**
 * @summary Relay fee pay
 */
export const usePostRelayFeePay = <
  TError = PostRelayFeePay401 | PostRelayFeePay500OneOf,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRelayFeePay>>,
      TError,
      { data: PostRelayFeePayBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRelayFeePay>>,
  TError,
  { data: PostRelayFeePayBody },
  TContext
> => {
  const mutationOptions = getPostRelayFeePayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get fee payer balance
 */
export const getFeePayerBalance = (signal?: AbortSignal) => {
  return customInstance<GetFeePayerBalance200Item[]>({
    url: `/api/fee-delegation/balance`,
    method: "GET",
    signal,
  });
};

export const getGetFeePayerBalanceQueryKey = () => {
  return [`/api/fee-delegation/balance`] as const;
};

export const getGetFeePayerBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeePayerBalance>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getFeePayerBalance>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeePayerBalanceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeePayerBalance>>
  > = ({ signal }) => getFeePayerBalance(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeePayerBalance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeePayerBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeePayerBalance>>
>;
export type GetFeePayerBalanceQueryError = unknown;

export function useGetFeePayerBalance<
  TData = Awaited<ReturnType<typeof getFeePayerBalance>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeePayerBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeePayerBalance>>,
          TError,
          Awaited<ReturnType<typeof getFeePayerBalance>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeePayerBalance<
  TData = Awaited<ReturnType<typeof getFeePayerBalance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeePayerBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeePayerBalance>>,
          TError,
          Awaited<ReturnType<typeof getFeePayerBalance>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeePayerBalance<
  TData = Awaited<ReturnType<typeof getFeePayerBalance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeePayerBalance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get fee payer balance
 */

export function useGetFeePayerBalance<
  TData = Awaited<ReturnType<typeof getFeePayerBalance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeePayerBalance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeePayerBalanceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get transaction by to address
 */
export const getPublicTransactionGetByToAddress = (
  params: GetPublicTransactionGetByToAddressParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetPublicTransactionGetByToAddress200>({
    url: `/public/to-address`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPublicTransactionGetByToAddressQueryKey = (
  params?: GetPublicTransactionGetByToAddressParams,
) => {
  return [`/public/to-address`, ...(params ? [params] : [])] as const;
};

export const getGetPublicTransactionGetByToAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
  TError = unknown,
>(
  params: GetPublicTransactionGetByToAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPublicTransactionGetByToAddressQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>
  > = ({ signal }) => getPublicTransactionGetByToAddress(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPublicTransactionGetByToAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>
>;
export type GetPublicTransactionGetByToAddressQueryError = unknown;

export function useGetPublicTransactionGetByToAddress<
  TData = Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
  TError = unknown,
>(
  params: GetPublicTransactionGetByToAddressParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
          TError,
          Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPublicTransactionGetByToAddress<
  TData = Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
  TError = unknown,
>(
  params: GetPublicTransactionGetByToAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
          TError,
          Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPublicTransactionGetByToAddress<
  TData = Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
  TError = unknown,
>(
  params: GetPublicTransactionGetByToAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get transaction by to address
 */

export function useGetPublicTransactionGetByToAddress<
  TData = Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
  TError = unknown,
>(
  params: GetPublicTransactionGetByToAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicTransactionGetByToAddress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPublicTransactionGetByToAddressQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get pot info
 */
export const getPotInfo = (params: GetPotInfoParams, signal?: AbortSignal) => {
  return customInstance<GetPotInfo200Item[]>({
    url: `/public/pot-info`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPotInfoQueryKey = (params?: GetPotInfoParams) => {
  return [`/public/pot-info`, ...(params ? [params] : [])] as const;
};

export const getGetPotInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getPotInfo>>,
  TError = unknown,
>(
  params: GetPotInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPotInfo>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPotInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPotInfo>>> = ({
    signal,
  }) => getPotInfo(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPotInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPotInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPotInfo>>
>;
export type GetPotInfoQueryError = unknown;

export function useGetPotInfo<
  TData = Awaited<ReturnType<typeof getPotInfo>>,
  TError = unknown,
>(
  params: GetPotInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPotInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPotInfo>>,
          TError,
          Awaited<ReturnType<typeof getPotInfo>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPotInfo<
  TData = Awaited<ReturnType<typeof getPotInfo>>,
  TError = unknown,
>(
  params: GetPotInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPotInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPotInfo>>,
          TError,
          Awaited<ReturnType<typeof getPotInfo>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPotInfo<
  TData = Awaited<ReturnType<typeof getPotInfo>>,
  TError = unknown,
>(
  params: GetPotInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPotInfo>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get pot info
 */

export function useGetPotInfo<
  TData = Awaited<ReturnType<typeof getPotInfo>>,
  TError = unknown,
>(
  params: GetPotInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPotInfo>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPotInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
